module.exports = __webpack_public_path__ + "static/AR0-7e536c5f604c49243f80db4a3026512c.png";